import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Icon (_props) {
  return <FontAwesomeIcon icon={_props.icon} fixedWidth />;
}

export default Icon;